module.exports = __webpack_public_path__ + "static/stalowe-1-09da55a5eae8094f921cc77ce11e8cdb.jpg";